import SVGIcon from "@/components/SVGIcon";
import styles from "./index.module.less";
import ModalCloseIcon from "@/assets/imgs/modal_close.svg?react";
import { useClickAway } from "ahooks";
import { useEffect, useRef } from "react";
import classNames from "classnames";

const MobileModal = ({
  open,
  title = "",
  onClose,
  children,
  centered = false,
  header,
}: {
  open: boolean;
  title?: string;
  onClose: () => void;
  children?: React.ReactNode;
  centered?: boolean;
  header?: React.ReactNode;
}) => {
  useEffect(() => {
    if (!open) return;
    if (centered) {

      window.gsap.set(`.${styles.mobileModal}`, {
        // transform: "translateY(100%)",
        opacity: 0,
      });
      window.gsap.to(`.${styles.mobileModal}`, {
        opacity: 1,
        // transform: "translateY(0)",
        duration: 0.3,
      });
    } else {

      window.gsap.set(`.${styles.mobileModal}`, {
        // transform: "translateY(100%)",
        // opacity: 0,
        height: "0",
      });
      window.gsap.to(`.${styles.mobileModal}`, {
        // opacity: 1,
        // transform: "translateY(0)",
        duration: 0.3,
        height: "auto",
      });
    }
  }, [open]);
  if (!open) return null;
  return (
    <div
      className={classNames(styles.mobileModal, {
        [styles.centered]: centered,
      })}
    >
      <div className={styles.mask}></div>
      <div className={styles.header}>
        {header || (
          <>
            <div>{title}</div>
            <SVGIcon
              className={styles.closeIcon}
              icon={<ModalCloseIcon />}
              onClick={onClose}
              width={20}
            />
          </>
        )}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};
export default MobileModal;
